import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktTreatmentExecutionContainerModel } from '../../../../../../models';

@Injectable({
  providedIn: 'root',
})
export class DgMktTreatmentExecutionService extends BaseApiTemplateService<DgMktTreatmentExecutionContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'treatment-executions/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatment-executions/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatment-executions/backoffice-ep';
    this.httpClient = http;
  }
}
